// extracted by mini-css-extract-plugin
export default {"Card":"ExplorationCard_Card__ZvkCX","Title":"ExplorationCard_Title__fGnSS","Image":"ExplorationCard_Image__SeH9y"};